'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const AnchorBarList = renderWithRef('SubNavList', null, (t, e)=>{
    let s = new Set([
        'swan-anchor-bar-list'
    ]), { children: a } = t;
    return jsx(RenderComp, {
        root: "ul",
        forwardedRef: e,
        classNames: s,
        props: t,
        children: a
    });
});

export { AnchorBarList };
